
class SlideToggle
{
  // ---------------------------------------------------------------------------------------------------------
	// --	SlideToggle
	// ---------------------------------------------------------------------------------------------------------

  constructor(dom)
  {
    console.log('SlideToggle')

    //DOM参照
    this.$dom = dom
    this.$target = $(this.$dom.attr('href'))

    //時間
    this.duration = parseInt(this.$dom.data('duration'))

    //ターゲットの初期表示
    this.$target.slideUp(0)

    //入力
    this.$dom.click(this.onSelect.bind(this))
  }

  onSelect(e)
  {
    e.preventDefault()

    //閉じる
    if(this.$dom.hasClass('isSelected'))
    {
      this.$dom.removeClass('isSelected')
      this.$target.slideUp(this.duration)
    }
    //開く
    else
    {
      this.$dom.addClass('isSelected')
      this.$target.slideDown(this.duration)
    }
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default SlideToggle
